"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import HoverableValue from "../hoverable_value";
function showValue(props, value) {
  if (props.onValueHighlighted) {
    return /* @__PURE__ */ jsx(
      HoverableValue,
      {
        value,
        onValueHighlighted: props.onValueHighlighted,
        onValueClick: props.onValueClick
      }
    );
  } else {
    return value;
  }
}
export default function Address(props) {
  if (props.source) {
    var source = props.source;
    var prefix = props.prefix || "";
    let country = source[prefix + "country"];
    if (country === "US" || country === "USA") {
      country = void 0;
    }
    const address = {
      name: source[prefix + "name"],
      line1: source[prefix + "address_line_1"],
      line2: source[prefix + "address_line_2"],
      city: source[prefix + "city"],
      state: source[prefix + "state"],
      postal_code: source[prefix + "postal_code"],
      country
    };
    return /* @__PURE__ */ jsxs("div", { className: "address", children: [
      address.name ? /* @__PURE__ */ jsx("div", { className: "address__line", children: showValue(props, address.name) }) : "",
      address.line1 ? /* @__PURE__ */ jsx("div", { className: "address__line", children: showValue(props, address.line1) }) : "",
      address.line2 ? /* @__PURE__ */ jsx("div", { className: "address__line", children: showValue(props, address.line2) }) : "",
      address.city || address.state || address.postal_code || address.country ? /* @__PURE__ */ jsxs("div", { className: "address__line", children: [
        address.city ? /* @__PURE__ */ jsx("span", { className: "address__piece", children: showValue(props, address.city) }) : "",
        address.city && address.state ? /* @__PURE__ */ jsx("span", { children: "," }) : "",
        address.state ? /* @__PURE__ */ jsx("span", { className: "address__piece", children: showValue(props, address.state) }) : "",
        address.postal_code ? /* @__PURE__ */ jsx("span", { className: "address__piece", children: showValue(props, address.postal_code) }) : "",
        address.country ? /* @__PURE__ */ jsx("span", { className: "address__piece", children: showValue(props, address.country) }) : ""
      ] }) : ""
    ] });
  } else {
    return /* @__PURE__ */ jsx("div", { children: props.children });
  }
}
